import { Div, Span } from '@kizi/core-components';
import type { DivProps } from '@kizi/core-components';
import { IconV2 as Icon, IconV2, withTooltip } from '@kizi/shared-components';
import React from 'react';
import type { MouseEventHandler } from 'react';
const IconWithTooltip = withTooltip(IconV2);

export interface ButtonCardProps extends DivProps {
  iconName: string;
  value: string;
  label: string;
  tooltip?: string;
  onClick?: MouseEventHandler;
}

export const ButtonCard: React.FC<ButtonCardProps> = ({
  iconName,
  value,
  label,
  tooltip,
  onClick,
}: ButtonCardProps) => {
  return (
    <Div
      flex={1}
      position="relative"
      borderRadius="8px"
      display="flex"
      alignItems="center"
      padding="8px"
      background="#F0F0EF"
    >
      <Div
        display="flex"
        alignItems="center"
        gridGap={2}
        onClick={onClick}
        style={{ cursor: 'pointer' }}
      >
        <Icon name={iconName} width={24} height={24} fill="main.2" />
        <Div display="flex" flexDirection="column" gridGap={1}>
          <Span
            color={'main.2'}
            fontFamily="heading"
            fontSize={4}
            fontWeight="700"
          >
            {value}
          </Span>
          <Span
            color={'supplementary.7'}
            fontFamily="heading"
            fontSize={2}
            fontWeight="500"
            css={{ whiteSpace: 'nowrap' }}
          >
            {label}
          </Span>
        </Div>
      </Div>
      {tooltip && (
        <IconWithTooltip
          name="info"
          size={14}
          css={{
            position: 'absolute',
            right: '4px',
            top: '4px',
            fill: '#BEC0C3',
            marginRight: '0!important',
          }}
          _tooltip={tooltip}
          cursor="pointer"
        />
      )}
    </Div>
  );
};
